// Mixtures Getters

export const getFullMixturesList = state => {
  return state.fullMixturesList
}

export const getMixturesList = state => {
  return state.mixturesList
}

export const getMixtureInfo = state => {
  return state.mixtureInfo
}
